// Maps the quote's allowed targets of the target tier to the plan shape BillingTerm and PlanCard read.
// Blocked terms (Monthly for an annual subscriber) are left out rather than shown disabled.
export default function termsForTargetTier(quote) {
  return quote.allowedTargets
    .filter((target) => target.tier === quote.targetPlan.tier && target.available)
    .map((target) => ({
      key: target.planType,
      price: target.price,
      freeMonths: target.freeMonths,
      downloadsPerMonth: target.downloadsPerMonth,
      generationsPerMonth: target.generationsPerMonth,
      isAvailable: target.available,
    }))
}
